import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import OnWarningFlagIcon from '../../../icons/OnWarningFlagIcon';
import { loadParticipantCircumstances } from '../../../store/participantService';

const ParticipantWarning = ({ participantId }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // LOCAL STATE
    const [showWarningFlag, setShowWarningFlag] = useState(false);

    // STORE STATE
    const participantCircumstances = useSelector(
        (state) => state.entities.participantService.currentParticipantCircumstances
    );

    // USE EFFECTS
    useEffect(() => {
        if (!participantId?.length) return;
        dispatch(loadParticipantCircumstances(participantId));
    }, [participantId]);

    useEffect(() => {
        const { pv, trainingEmploymentRestriction, ucb } = participantCircumstances;
        setShowWarningFlag(pv || trainingEmploymentRestriction || ucb);
    }, [participantCircumstances]);

    // EVENT HANDLERS
    const onNavigate = () => {
        navigate('/edit_participant', { state: { accordionPanel: 'circumstances' } });
    };

    // RENDER
    if (!showWarningFlag) return;
    return <OnWarningFlagIcon onClick={onNavigate} />;
};

ParticipantWarning.propTypes = {
    participantId: PropTypes.string
};

export default ParticipantWarning;
